export default function utils() {
  
  $('html').removeClass('no-js');
  
  $('a.external').click( function() {
    window.open(this.href);
    return false;
  });
 
  $( document ).ready(function() {
    if($('.bonifico-btn').length > 0) {
      $('.bonifico-btn').on('click', function(e) { 
        e.preventDefault();
        $("#bonifico").slideToggle();
      });
    }
  });
  
  
  function toggleMenu() {
    var $toggleMenu = $('#toggle-menu-btn');
    $toggleMenu.on('click', function(e) {
      e.preventDefault()
      $(this).parents('.header').toggleClass('open');
      $(this).toggleClass('open');
			$("#nav").slideToggle();
    })
  }

  if($('#toggle-menu-btn').length > 0) {
    $( document ).ready(function() {
      toggleMenu()
    });
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/utils.js